import { render, staticRenderFns } from "./IntRoutes.vue?vue&type=template&id=bdbe9d68&"
import script from "./IntRoutes.vue?vue&type=script&lang=js&"
export * from "./IntRoutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports